import { useState, useCallback } from 'react';
import { LocationCoords, SelectionMode } from '../types/fare';

export function useMapInteraction() {
  const [selectionMode, setSelectionMode] = useState<SelectionMode>('none');
  const [pickupMarker, setPickupMarker] = useState<LocationCoords | null>(null);
  const [destinationMarker, setDestinationMarker] = useState<LocationCoords | null>(null);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);

  const startPickupSelection = useCallback(() => {
    setSelectionMode('pickup');
  }, []);

  const startDestinationSelection = useCallback(() => {
    setSelectionMode('destination');
  }, []);

  const cancelSelection = useCallback(() => {
    setSelectionMode('none');
  }, []);

  const handleMapClick = useCallback((location: LocationCoords) => {
    if (selectionMode === 'pickup') {
      setPickupMarker(location);
      setSelectionMode('none');
      return 'pickup';
    } else if (selectionMode === 'destination') {
      setDestinationMarker(location);
      setSelectionMode('none');
      return 'destination';
    }
    return null;
  }, [selectionMode]);

  const clearMarkers = useCallback(() => {
    setPickupMarker(null);
    setDestinationMarker(null);
    setSelectedRouteIndex(0);
  }, []);

  const setPickup = useCallback((location: LocationCoords) => {
    setPickupMarker(location);
  }, []);

  const setDestination = useCallback((location: LocationCoords) => {
    setDestinationMarker(location);
  }, []);

  return {
    selectionMode,
    pickupMarker,
    destinationMarker,
    selectedRouteIndex,
    startPickupSelection,
    startDestinationSelection,
    cancelSelection,
    handleMapClick,
    clearMarkers,
    setPickup,
    setDestination,
    setSelectedRouteIndex,
  };
}

